/* Kahaus: klik w DOWOLNE miejsce karty (zdjęcie, tło) → strona produktu.
   Poza kontrolkami (kropki koloru, „do koszyka", formularze). Naprawia „tylko tytuł klikalny". */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('button, .kahaus-dot-btn, .kahaus-card-dots, .quick-add, product-form, modal-opener, quick-add-modal, input, select, textarea, label')) return;
    var card = t.closest('.product-card-wrapper, .card-wrapper');
    if (!card) return;
    var link = card.querySelector('a.kahaus-media-link[href], .card__heading a[href], a.full-unstyled-link[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;
    var clickedA = t.closest('a[href]');
    if (clickedA && clickedA.href === link.href) return; // właściwy link — zostaw natywnie
    e.preventDefault();
    window.location.href = link.href;
  });
})();

/* Kahaus: karta — klik kropki koloru przełącza WARIANT (zdjęcie główne + hover per-SKU + link). */
(function () {
  function cardOf(el) { return el.closest('.card-wrapper') || el.closest('.card'); }
  function mediaImgs(card) { return card ? card.querySelectorAll('.card__media .media img') : []; }
  function applyDot(btn) {
    var card = cardOf(btn); if (!card) return;
    var imgs = mediaImgs(card), main = imgs[0], sec = imgs[1];
    if (main && btn.dataset.kahausImg) { main.removeAttribute('srcset'); main.src = btn.dataset.kahausImg; }
    if (sec && btn.dataset.kahausImg1) { sec.removeAttribute('srcset'); sec.src = btn.dataset.kahausImg1; }
    if (btn.dataset.kahausUrl) {
      card.querySelectorAll('a.kahaus-media-link, .card__heading a, a.card__link, a.full-unstyled-link').forEach(function (a) { a.href = btn.dataset.kahausUrl; });
    }
    var dots = btn.closest('.kahaus-card-dots');
    if (dots) dots.querySelectorAll('.kahaus-dot-btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.kahaus-dot-btn');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    applyDot(btn);
  });
  // init: hover per-SKU = 2. zdjęcie AKTYWNEGO koloru (a nie innego wariantu/rodziny)
  function kahausDotsInit() {
    document.querySelectorAll('.kahaus-card-dots').forEach(function (dots) {
      var btn = dots.querySelector('.kahaus-dot-btn.is-active') || dots.querySelector('.kahaus-dot-btn');
      var card = cardOf(dots);
      if (!btn || !card) return;
      var sec = mediaImgs(card)[1];
      if (sec && btn.dataset.kahausImg1) { sec.removeAttribute('srcset'); sec.src = btn.dataset.kahausImg1; }
    });
  }
  if (document.readyState !== 'loading') kahausDotsInit(); else document.addEventListener('DOMContentLoaded', kahausDotsInit);
})();

/* Kahaus: wybór języka dostosowuje kraj/walutę.
   Mapa język -> kraj; PL->PLN, RO->RON, HU->HUF, reszta strefa euro (EN->IE).
   Doklejamy country_code do formularza języka (capture — przed submitem Dawn),
   więc Shopify przełącza język I walutę jednym żądaniem. */
(function () {
  var LANG_COUNTRY = { pl: 'PL', en: 'IE', de: 'DE', fr: 'FR', it: 'IT', es: 'ES', nl: 'NL', ro: 'RO', hu: 'HU', sk: 'SK' };
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest && e.target.closest('.kahaus-loc-language .disclosure__link[data-value]');
      if (!link) return;
      var iso = (link.dataset.value || '').toLowerCase();
      var country = LANG_COUNTRY[iso];
      var form = link.closest('form');
      if (!country || !form) return;
      // przejmujemy submit: ustawiamy język I kraj razem, potem sami wysyłamy
      e.preventDefault();
      e.stopPropagation();
      var lc = form.querySelector('input[name="locale_code"]');
      if (lc) lc.value = iso;
      var cc = form.querySelector('input[name="country_code"]');
      if (!cc) {
        cc = document.createElement('input');
        cc.type = 'hidden';
        cc.name = 'country_code';
        form.appendChild(cc);
      }
      cc.value = country;
      HTMLFormElement.prototype.submit.call(form);
    },
    true
  );
})();

/* Kahaus PDP v0.3.0: mirror ceny do CTA + sticky „do koszyka" (mobile) + kompaktowy header na scroll */
(function () {
  // -- mirror aktualnej ceny do przycisków „do koszyka" i paska sticky --
  function currentPrice() {
    var box = document.querySelector('[id^="price-"]');
    if (!box) return '';
    var onSale = box.classList.contains('price--on-sale') || (box.closest && box.closest('.price--on-sale'));
    var el =
      (onSale && box.querySelector('.price-item--sale')) ||
      box.querySelector('.price-item--regular') ||
      box.querySelector('.price-item');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function mirrorPrice() {
    var val = currentPrice();
    if (!val) return;
    var nodes = document.querySelectorAll('[data-kahaus-atc-price]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = (nodes[i].hasAttribute('data-price-dash') ? '— ' : '') + val;
    }
  }
  var priceBox = document.querySelector('[id^="price-"]');
  if (priceBox && 'MutationObserver' in window) {
    new MutationObserver(mirrorPrice).observe(priceBox, { childList: true, subtree: true, characterData: true });
  }
  mirrorPrice();

  // -- przyklejony pasek „do koszyka" na mobile --
  var sticky = document.querySelector('.kahaus-sticky-atc[data-kahaus-sticky]');
  if (sticky) {
    var realBtn = document.getElementById(sticky.getAttribute('data-atc-target'));
    var stickyBtn = sticky.querySelector('[data-kahaus-sticky-add]');
    if (realBtn && stickyBtn) {
      stickyBtn.addEventListener('click', function () { realBtn.click(); });
    }
    var anchor = realBtn || document.querySelector('.product__info-container');
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            sticky.classList.toggle('is-visible', !entries[i].isIntersecting);
          }
        },
        { rootMargin: '0px 0px -20px 0px' }
      ).observe(anchor);
    }
  }

  // -- kompaktowy header po przewinięciu w dół --
  var wrap = document.querySelector('sticky-header.header-wrapper') || document.querySelector('.header-wrapper');
  if (wrap) {
    var ticking = false;
    function updHeader() {
      ticking = false;
      wrap.classList.toggle('kahaus-header-compact', (window.scrollY || window.pageYOffset || 0) > 60);
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          (window.requestAnimationFrame || window.setTimeout)(updHeader);
        }
      },
      { passive: true }
    );
    updHeader();
  }
})();

/* Kahaus: hero rotator (losowe produkty z różnych rodzin) + quick-add „+" */
(function () {
  var rot = document.querySelector('[data-kahaus-hero-rotator]');
  if (!rot) return;
  var box = rot.querySelector('.kahaus-hero__slides');
  var all = Array.prototype.slice.call(rot.querySelectorAll('.kahaus-hero__slide'));
  if (!box || !all.length) return;

  var count = Math.max(1, parseInt(rot.getAttribute('data-count'), 10) || 5);
  var interval = Math.max(2000, parseInt(rot.getAttribute('data-interval'), 10) || 4500);

  /* Przeplot rodzin NA ZMIANĘ (bestseller / nowość / bestseller / ...), nie losowanie.
     Kolejność wewnątrz rodziny zostaje taka, jak wyrenderował ją Liquid — czyli kolejność
     kolekcji: bestsellery wg realnej sprzedaży, nowości od najnowszej. Duplikat (produkt
     w obu kolekcjach) wchodzi tylko raz. */
  var groups = [], gIdx = {};
  all.forEach(function (s) {
    var f = s.getAttribute('data-family') || '';
    if (gIdx[f] === undefined) { gIdx[f] = groups.length; groups.push([]); }
    groups[gIdx[f]].push(s);
  });
  var maxLen = 0;
  groups.forEach(function (g) { if (g.length > maxLen) maxLen = g.length; });
  var chosen = [], seenH = {};
  for (var r = 0; r < maxLen && chosen.length < count; r++) {
    for (var g = 0; g < groups.length && chosen.length < count; g++) {
      var s = groups[g][r];
      if (!s) continue;
      var h = s.getAttribute('data-handle') || '';
      if (h) { if (seenH[h]) continue; seenH[h] = 1; }
      chosen.push(s);
    }
  }
  all.forEach(function (s) { s.classList.remove('is-active'); });
  chosen.forEach(function (s) { box.appendChild(s); });

  var dotsWrap = rot.querySelector('[data-hero-dots]');
  var dots = [];
  if (dotsWrap) {
    dotsWrap.innerHTML = '';
    chosen.forEach(function (_, k) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'kahaus-hero__dot';
      b.setAttribute('aria-label', 'Produkt ' + (k + 1));
      b.addEventListener('click', function () { go(k); });
      dotsWrap.appendChild(b); dots.push(b);
    });
  }

  var idx = 0, timer = null;
  function paint() {
    /* is-next: CSS chowa <img> pozostałych slajdów (display:none wstrzymuje lazy), więc ściąga się tylko
       bieżący i następny kadr, a nie 8 naraz przy starcie (~0,5 MB na telefonie, 18.10). */
    var nx = chosen.length > 1 ? (idx + 1) % chosen.length : -1;
    chosen.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); s.classList.toggle('is-next', k === nx); });
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
  }
  function go(k) { idx = (k + chosen.length) % chosen.length; paint(); restart(); }
  function restart() { if (timer) clearInterval(timer); if (chosen.length > 1) timer = setInterval(function () { go(idx + 1); }, interval); }
  paint(); restart();
  /* Pauza pod kursorem TYLKO przy prawdziwej myszy: na telefonie dotknięcie odpala `mouseenter`,
     a `mouseleave` nie przychodzi nigdy → rotator stawał na zawsze (zmierzone 27.09, iPhone 13). */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    rot.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    rot.addEventListener('mouseleave', restart);
  }

  rot.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.kahaus-hero__add');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant');
    if (!id || btn.classList.contains('is-loading')) return;
    var span = btn.querySelector('span'), orig = span ? span.textContent : '+';
    btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var wantsDrawer = drawer && typeof drawer.renderContents === 'function';
    var body = { items: [{ id: id, quantity: 1 }], sections_url: window.location.pathname };
    body.sections = wantsDrawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.classList.remove('is-loading'); btn.classList.add('is-added');
      if (span) span.textContent = '✓';
      setTimeout(function () { btn.classList.remove('is-added'); if (span) span.textContent = orig; }, 1600);
      if (res && res.sections) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res.sections['cart-icon-bubble']) bubble.innerHTML = res.sections['cart-icon-bubble'];
        if (wantsDrawer && res.sections['cart-drawer']) {
          drawer.classList.remove('is-empty');
          try { drawer.renderContents(res); } catch (err) {}
        }
      }
    }).catch(function () { btn.classList.remove('is-loading'); if (span) span.textContent = orig; });
  });
})();


/* ===== Auto-przełączanie rozmiaru gdy wybrany kolor niedostępny w bieżącym rozmiarze (i18n toast) =====
   Capture-phase: korygujemy checked rozmiaru ZANIM variant-selects Dawn odczyta formularz -> 1 fetch, bez migotania. */
(function () {
  var SIZE_RE = /size|rozmiar|gr(ö|o)sse|taille|maat|talla|taglia/i;
  var COLOR_RE = /colou?r|kolor|farbe|couleur|kleur|colore/i;
  function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/["\\\]]/g, '\\$&'); }
  var toastEl;
  function toast(msg) {
    if (!msg) return;
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'kahaus-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-show');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-show'); }, 4500);
  }
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
    if (!COLOR_RE.test(input.getAttribute('data-option-name') || '')) return;
    var vs = input.closest('variant-selects'); if (!vs) return;
    var mEl = vs.querySelector('[data-kahaus-variants]'); if (!mEl) return;
    var data; try { data = JSON.parse(mEl.textContent); } catch (_) { return; }
    var names = data.optionNames || [], variants = data.variants || [];
    var si = -1, ci = -1;
    for (var i = 0; i < names.length; i++) { if (si < 0 && SIZE_RE.test(names[i])) si = i; if (ci < 0 && COLOR_RE.test(names[i])) ci = i; }
    if (si < 0 || ci < 0) return; // tylko produkty z OBIEMA opcjami
    var color = input.value, sizeName = names[si];
    var sizeRadio = vs.querySelector('input[type="radio"][data-option-name="' + cssEsc(sizeName) + '"]:checked');
    if (!sizeRadio) return;
    var isAvail = false, newSize = null;
    for (var j = 0; j < variants.length; j++) {
      var v = variants[j];
      if (v.values[ci] === color) {
        if (v.values[si] === sizeRadio.value && v.available) { isAvail = true; break; }
        if (newSize === null && v.available) newSize = v.values[si];
      }
    }
    if (isAvail || !newSize || newSize === sizeRadio.value) return;
    var newRadio = vs.querySelector('input[type="radio"][data-option-name="' + cssEsc(sizeName) + '"][value="' + cssEsc(newSize) + '"]');
    if (!newRadio) return;
    newRadio.checked = true; // synchronicznie, przed handlerem Dawn (bubble)
    var tpl = mEl.getAttribute('data-switch-msg') || '';
    toast(tpl.replace('%COLOR%', color).replace('%SIZE%', newSize));
  }, true); // capture

  // === Kahaus ticker: „ile wydrukowaliśmy, odkąd tu jesteś" ===
  // Startuje od ZERA przy wejściu na stronę — świadomie, bo historycznego baseline'u
  // nie mamy i nie zamierzamy go zmyślać. Tempo (data-rate) = minuty druku na minutę
  // zegara, zmierzone ze sprzedaży. Licznik jest więc prawdziwy w każdej sekundzie.
  // Tyka 1×/s (nie 60×/s) — zero kosztu dla baterii.
  if (window.customElements && !customElements.get('kahaus-ticker')) {
    customElements.define('kahaus-ticker', class extends HTMLElement {
      connectedCallback() {
        var rate = parseFloat(this.getAttribute('data-rate'));
        if (!isFinite(rate) || rate <= 0) return; // brak tempa = licznik zostaje na „0"
        this.sep = this.getAttribute('data-sep') || ',';
        this.unit = this.getAttribute('data-unit') || '';
        this.perSec = rate / 60;
        this.t0 = Date.now();
        // WCAG 2.2.2 — ruchoma treść musi dać się zatrzymać. Przy reduced-motion
        // pokazujemy statyczny wynik po minucie zamiast animacji.
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) { this.render(rate); return; }
        var self = this;
        this.tick = function () { self.render((Date.now() - self.t0) / 1000 * self.perSec); };
        this.tick();
        this.timer = setInterval(this.tick, 1000);
        // Karta w tle = licznik i tak przeliczy się z zegara przy powrocie; nie mielimy w tle.
        this._vis = function () {
          if (document.hidden) { clearInterval(self.timer); self.timer = null; }
          else if (!self.timer) { self.tick(); self.timer = setInterval(self.tick, 1000); }
        };
        document.addEventListener('visibilitychange', this._vis);
      }
      render(v) {
        // Poniżej 100 pokazujemy 1 miejsce po przecinku — inaczej gramy (4,16/min) stałyby
        // w miejscu przez ~14 s i licznik wyglądałby na zepsuty. Powyżej 100 ułamek to szum.
        var s = v < 100 ? v.toFixed(1).replace('.', this.sep) : String(Math.floor(v));
        this.textContent = this.unit ? s + ' ' + this.unit : s;
      }
      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
        if (this._vis) document.removeEventListener('visibilitychange', this._vis);
      }
    });
  }

  // Szerokość z CDN Shopify — URL-e z metapola `custom.gallery` są SUROWE (nie obiekty `image`),
  // więc bez tego parametru miniatura 140 px ciągnie oryginał: 441 kB zamiast 43 kB,
  // sześć sztuk na kartę produktu (zmierzone 2026-09-07, karta ważyła 3,6 MB).
  function kgW(u, w) {
    if (!u || u.indexOf('width=') > -1) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  // === Kahaus per-variant gallery: cała galeria przełącza się pod SKU ===
  // Dane z metapola custom.gallery (list.url z BaseLinkera), hook = input[name="id"] change.
  if (window.customElements && !customElements.get('kahaus-gallery')) {
    customElements.define('kahaus-gallery', class extends HTMLElement {
      connectedCallback() {
        try { this.map = JSON.parse(this.querySelector('[data-kg-map]').textContent); } catch (_) { this.map = {}; }
        // Alt przełącza się RAZEM ze zdjęciem — bez tego po kliknięciu w kolor zostawał opis
        // poprzedniego wariantu (albo żaden). Mapa: nazwa pliku -> alt przetlumaczony przez Liquid.
        var altEl = this.querySelector('[data-kg-alt]');
        try { this.altMap = altEl ? JSON.parse(altEl.textContent) : {}; } catch (_) { this.altMap = {}; }
        this.fallbackAlt = this.getAttribute('data-kg-fallback-alt') || '';
        this.mainWrap = this.querySelector('[data-kg-main]');
        this.thumbsEl = this.querySelector('[data-kg-thumbs]');
        this.current = this.getAttribute('data-current-variant');
        this.urls = this.map[this.current] || [];
        var self = this;
        if (this.thumbsEl) {
          this.thumbsEl.addEventListener('click', function (e) {
            var b = e.target && e.target.closest ? e.target.closest('[data-kg-idx]') : null;
            if (b) self.activate(parseInt(b.getAttribute('data-kg-idx'), 10));
          });
        }
        this._onChange = function (e) {
          var t = e.target;
          if (t && t.matches && t.matches('input[name="id"]')) self.setVariant(t.value);
        };
        document.addEventListener('change', this._onChange, true);
      }
      disconnectedCallback() { document.removeEventListener('change', this._onChange, true); }
      setVariant(vid) {
        if (!vid || vid === this.current) return;
        var urls = this.map[vid];
        if (!urls || !urls.length) return;
        this.current = vid; this.urls = urls;
        this.setAttribute('data-current-variant', vid);
        if (this.thumbsEl) {
          var html = '';
          for (var i = 0; i < urls.length; i++) {
            html += '<li><button type="button" class="kahaus-gallery__thumb' + (i === 0 ? ' is-active' : '') +
              '" data-kg-idx="' + i + '" aria-label="' + (i + 1) + '"><img alt="' + String(this.altFor(urls[i])).replace(/"/g, '&quot;') + '" src="' + kgW(urls[i], 300) +
              '" alt="" loading="lazy" width="140" height="140"></button></li>';
          }
          this.thumbsEl.innerHTML = html;
          this.thumbsEl.style.display = urls.length > 1 ? '' : 'none';
        }
        this.setMain(urls[0]);
      }
      activate(i) {
        if (!this.urls) this.urls = this.map[this.current] || [];
        var u = this.urls[i]; if (!u) return;
        this.setMain(u);
        if (this.thumbsEl) {
          var btns = this.thumbsEl.querySelectorAll('.kahaus-gallery__thumb');
          for (var b = 0; b < btns.length; b++) btns[b].classList.toggle('is-active', b === i);
        }
      }
      altFor(u) {
        if (!u) return this.fallbackAlt;
        var name = String(u).split('?')[0].split('/').pop();
        return this.altMap[name] || this.fallbackAlt;
      }
      setMain(u) {
        if (!this.mainWrap) return;
        var img = this.mainWrap.querySelector('[data-kg-main-img]');
        if (!img) { img = document.createElement('img'); img.setAttribute('data-kg-main-img', ''); img.width = 1200; img.height = 1200; this.mainWrap.appendChild(img); }
        img.src = kgW(u, 1200);
        img.alt = this.altFor(u);
      }
    });
  }
})();

/* Kahaus mobile: kropki pozycji dla przesuwanego pasa zdjęć w karcie (swipe lewo/prawo). */
(function () {
  /* HTML niesie tylko 1. slajd; reszta adresów w data-kahaus-ms-more (spacją). Slajdy dobudowujemy przy
     pierwszym dotknięciu pasa / strzałce — wcześniej 12 slajdów w HTML i 2. zdjęcie każdej karty ściągane od razu. */
  function more(strip) { return (strip.getAttribute('data-kahaus-ms-more') || '').split(' ').filter(Boolean); }
  function fill(strip) {
    if (strip._kahausFilled) return;
    strip._kahausFilled = true;
    var first = strip.querySelector('.kahaus-mswipe__slide');
    var fimg = first && first.querySelector('img');
    if (!first) return;
    var w = strip.clientWidth || 0;
    var sizes = w ? w + 'px' : (fimg && fimg.getAttribute('sizes')) || '100vw';
    more(strip).forEach(function (u) {
      var a = first.cloneNode(false);
      var img = document.createElement('img');
      img.className = 'kahaus-mswipe__img';
      img.src = u;
      img.srcset = u.replace(/width=720/, 'width=360') + ' 360w, ' + u.replace(/width=720/, 'width=540') + ' 540w, ' + u + ' 720w';
      img.sizes = sizes;
      img.alt = fimg ? fimg.alt : '';
      img.loading = 'lazy';
      img.width = 720; img.height = 720;
      img.draggable = false;
      a.appendChild(img);
      strip.appendChild(a);
    });
  }
  function build(strip) {
    if (strip._kahausDots) return;
    var total = 1 + more(strip).length;
    var slides = strip.getElementsByClassName('kahaus-mswipe__slide');
    if (total < 2) return;
    strip._kahausDots = true;
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      strip.addEventListener(ev, function () { fill(strip); }, { passive: true, once: true });
    });
    var dots = document.createElement('div');
    dots.className = 'kahaus-mswipe__dots';
    for (var i = 0; i < total; i++) {
      var d = document.createElement('span');
      d.className = 'kahaus-mswipe__dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(d);
    }
    // overlay kropek trzymamy w .card__media (poza scrollującym pasem), żeby nie jeździły ze zdjęciami
    var host = strip.parentNode || strip;
    host.appendChild(dots);
    // strzałki lewo/prawo — klik zmienia zdjęcie (pętla na końcach); pomarańczowe, klimat KRAFT
    function makeArrow(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kahaus-mswipe__arrow kahaus-mswipe__arrow--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', dir < 0 ? 'Poprzednie zdjęcie' : 'Następne zdjęcie');
      b.innerHTML = dir < 0
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="square"/></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="square"/></svg>';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        fill(strip);
        var w = strip.clientWidth || 1;
        var n = slides.length;
        var cur = Math.round(strip.scrollLeft / w);
        var to = (cur + (dir < 0 ? -1 : 1) + n) % n;
        if (strip.scrollTo) strip.scrollTo({ left: to * w, behavior: 'smooth' });
        else strip.scrollLeft = to * w;
      });
      return b;
    }
    host.appendChild(makeArrow(-1));
    host.appendChild(makeArrow(1));
    var ticking = false;
    strip.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      (window.requestAnimationFrame || window.setTimeout)(function () {
        ticking = false;
        var w = strip.clientWidth || 1;
        var idx = Math.round(strip.scrollLeft / w);
        var ds = dots.children;
        for (var k = 0; k < ds.length; k++) ds[k].classList.toggle('is-active', k === idx);
      });
    }, { passive: true });
  }
  function init() {
    if (window.matchMedia && !window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('[data-kahaus-mswipe]').forEach(build);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* Kahaus: reveal na scroll wg POŁOŻENIA — hero/USP/kafelki kategorii ORAZ karty produktów.
   Karty przejmujemy od Dawn (zdejmujemy jego jednolity zjazd), żeby też wjeżdżały wg położenia.
   Lewa→z lewej, prawa→z prawej, środek→z dołu; mobile→z dołu (bez poziomego scrolla). */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = '.kahaus-kchip, .kahaus-usp__tile, .kahaus-hero__content, .kahaus-hero__media, .kahaus-hero__stamp, .product-grid > .grid__item';
  var DAWN = ['scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen', 'scroll-trigger--visible'];
  var mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('kv-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.02 });
  function strip(n) { DAWN.forEach(function (c) { n.classList.remove(c); }); }
  function groupOf(el) { return el.closest('ul.product-grid, .kahaus-kchips, .kahaus-usp__grid, .kahaus-hero__grid') || el.parentNode; }
  function run() {
    // przejmij karty od Dawn: zdejmij scroll-trigger z siatek, ich owijek i pojedynczych kart
    [].slice.call(document.querySelectorAll('.product-grid, .product-grid > .grid__item')).forEach(strip);
    [].slice.call(document.querySelectorAll('slider-component')).forEach(function (sc) { if (sc.querySelector('.product-grid')) strip(sc); });
    var counts = (typeof Map === 'function') ? new Map() : null;
    [].slice.call(document.querySelectorAll(SEL)).forEach(function (el) {
      if (el.hasAttribute('data-kv')) return;
      if (el.classList.contains('scroll-trigger') || el.closest('.scroll-trigger')) return;
      var r = el.getBoundingClientRect();
      if (!r.width) return;
      var cx = (r.left + r.width / 2) / (window.innerWidth || 1);
      var x = 0, y = 0;
      if (mobile) { y = 24; } else if (cx < 0.4) { x = -34; } else if (cx > 0.6) { x = 34; } else { y = 28; }
      el.style.setProperty('--kvx', x + 'px');
      el.style.setProperty('--kvy', y + 'px');
      var g = groupOf(el);
      var c = counts ? (counts.get(g) || 0) : 0;
      el.style.setProperty('--kvd', Math.min(c * 55, 350) + 'ms');
      if (counts) counts.set(g, c + 1);
      el.setAttribute('data-kv', '');
      io.observe(el);
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  // bezpiecznik: po 3.5s pokaż wszystko, co jeszcze nie weszło (gdyby observer coś pominął)
  setTimeout(function () {
    document.querySelectorAll('[data-kv]:not(.kv-in)').forEach(function (el) { el.classList.add('kv-in'); });
  }, 3500);
})();

/* ══════════════════════════════════════════════════════════════════════
   Ticker czasów druku na /about-us (kahaus-proces.liquid).

   TO NIE JEST OZDOBA. Research (07-17) nie dał ŻADNYCH danych o animacjach, więc
   parallax/scroll-reveal wyleciały. Ten licznik zostaje, bo bodźcem w eksperymencie
   Buella & Nortona (Management Science 2011, F(1,212)=10,68) był ANIMOWANY KOMUNIKAT
   TEKSTOWY o wykonywanej pracy — to najbliższy realizowalny odpowiednik.

   Dane: <li> renderowane przez Liquid z PRODUKTU (tytuł tłumaczy się sam przez Markets,
   zdjęcie zawsze pasuje do modelu). Czas: Janusz sp_print_time_min = czas NA SZTUKĘ.
   reduced-motion: nie startujemy. Zmiana tu = zmiana w bliźniaku.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  var roots = document.querySelectorAll('[data-kahaus-tick]');
  if (!roots.length) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function hms(s) {
    var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = Math.floor(s % 60);
    return h + ':' + pad(m) + ':' + pad(x);
  }

  Array.prototype.forEach.call(roots, function (root) {
    var items = [].map.call(root.querySelectorAll('.kahaus-ab-tick__item'), function (li) {
      return { sec: +li.dataset.sec, g: li.dataset.g, name: li.dataset.name,
               url: li.dataset.url, plate: li.dataset.plate, photo: li.dataset.photo };
    }).filter(function (d) { return d.sec > 0; });
    if (!items.length) return;

    var elT = root.querySelector('[data-kahaus-tick-time]');
    var elN = root.querySelector('[data-kahaus-tick-name]');
    var elG = root.querySelector('[data-kahaus-tick-grams]');
    var elF = root.querySelector('[data-kahaus-tick-fill]');
    var elP = root.querySelector('[data-kahaus-tick-plate]');   // render izo „na stole"
    var elPh = root.querySelector('[data-kahaus-tick-photo]');  // zdjęcie produktu w hero
    var elL = root.querySelector('[data-kahaus-tick-link]');
    if (!elT) return;

    var unitG = root.dataset.unitG || 'g';
    var max = +root.dataset.max || items.reduce(function (a, d) { return Math.max(a, d.sec); }, 1);
    var RUN = 1400, HOLD = 2800;
    var i = 0, raf = 0, timer = 0, running = false;

    // Wstępne wczytanie — inaczej pierwsza podmiana mruga.
    items.forEach(function (d) {
      [d.plate, d.photo].forEach(function (u) { if (u) { var im = new Image(); im.src = u; } });
    });

    function swap(el, src, alt) {
      if (!el || !src || el.getAttribute('src') === src) return;
      var next = new Image();
      next.src = src;
      var apply = function () {
        el.src = src;
        // width/height z `image_tag` opisują STARY obraz — zostawione, każą przeglądarce
        // policzyć inne proporcje i strona drga. Ramka ma rządzić, nie atrybuty.
        el.removeAttribute('srcset');
        el.removeAttribute('width');
        el.removeAttribute('height');
        el.removeAttribute('sizes');
        el.alt = alt || '';
        requestAnimationFrame(function () { el.style.opacity = '1'; });
      };
      el.style.opacity = '0';
      // 320 ms = czas przejścia z CSS; dopiero potem podmiana, żeby nie mrugnąć starym
      setTimeout(function () {
        (next.decode ? next.decode().catch(function () {}) : Promise.resolve()).then(apply);
      }, 320);
    }

    function show(idx) {
      var d = items[idx];
      if (!d) return;
      var t0 = performance.now();
      if (elN) elN.textContent = d.name || '';
      if (elG) elG.textContent = d.g ? d.g + ' ' + unitG : '';
      if (elF) elF.style.width = ((d.sec / max) * 100).toFixed(1) + '%';
      // Przenikanie zamiast cięcia: gasimy → czekamy aż NOWY obraz się zdekoduje →
      // podmieniamy → zapalamy. `decode()` gwarantuje, że nie zapalimy pustej ramki.
      // Ramki mają stały aspect-ratio w CSS, więc podmiana nie rusza layoutu.
      swap(elPh, d.photo, d.name);
      swap(elP, d.plate, d.name);
      if (elL && d.url) elL.href = d.url;

      function frame(t) {
        var p = Math.min(1, (t - t0) / RUN);
        elT.textContent = hms(d.sec * (1 - Math.pow(1 - p, 3)));
        if (p < 1) { raf = requestAnimationFrame(frame); return; }
        elT.textContent = hms(d.sec);
        timer = setTimeout(function () { i = (i + 1) % items.length; show(i); }, HOLD);
      }
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(frame);
    }

    function start() { if (!running) { running = true; show(i); } }
    function stop() { running = false; cancelAnimationFrame(raf); clearTimeout(timer); }

    // Nie odliczaj w tle — licznik ma sens tylko, gdy ktoś patrzy.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? start() : stop(); });
      }, { threshold: 0.25 }).observe(root);
    } else { start(); }
  });
})();

/* ══════════════════════════════════════════════════════════════════════
   Liczniki farmy na /about-us — ZEGARY REALNEGO CZASU, nie stopery od wejścia.

   Do 07-17 licznik startował od zera przy każdym wejściu, bo nie mieliśmy baseline'u
   („rate = fakt o teraz, suma = twierdzenie o przeszłości"). Teraz baseline jest:
   model od 03.2026 oparty na twardych punktach, więc każdy widzi TĘ SAMĄ liczbę
   o tej samej porze — a nie „0" po odświeżeniu.

   <kahaus-run>    — wartość narastająca: base + (teraz − data odniesienia) × tempo/dobę
                     data-fmt="hms" → H:MM:SS (godziny druku, sekundy lecą ~18×/s)
                     data-fmt="num" → liczba z data-dec miejscami (kg filamentu)
   <kahaus-solar>  — jak wyżej, ale przyrost TYLKO w dzień (krzywa słońca) — w nocy stoi
   <kahaus-pieces> — sztuki + odliczanie MM:SS do kolejnej

   Wspólne: `prefers-reduced-motion` → wartość policzona raz, bez tykania (WCAG 2.2.2).
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  var LAT = 50.03 * Math.PI / 180;   // Niepołomice
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return n < 10 ? '0' + n : String(n); }
  // Separator tysięcy: JAWNY \u0020 (zwykła spacja), nie literał.
  // 🧨 Siedział tu U+202F (NARROW NO-BREAK SPACE) — w edytorze wygląda IDENTYCZNIE jak
  // spacja, a przy `letter-spacing: -0.03em` na wielkim boldzie jest praktycznie
  // niewidoczny: „7794,586" zamiast „7 794,586". Grupowanie „działało", tylko efektu
  // nie było widać. Kod znaku wprost = następny raz to widać w diffie.
  function grouped(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '\u0020'); }

  function fmtNum(v, dec, sep) {
    var s = v.toFixed(dec);
    var parts = s.split('.');
    return grouped(parts[0]) + (parts[1] ? sep + parts[1] : '');
  }
  // Lata druku z dokładnością do sekundy: 24:187:09:36:12 (Y:DDD:HH:MM:SS).
  // 8 953 dni czytało się jak numer, 24,5 roku maszynogodzin czyta się jak fakt.
  // Rok druku przybywa co ~20,5 dnia realnego (17,8 dnia druku na dobę).
  function fmtYdhms(days) {
    var y = Math.floor(days / 365.25);
    var rd = days - y * 365.25;
    var d = Math.floor(rd);
    var rem = (rd - d) * 86400;
    return grouped(y) + ':' + pad3(d) + ':' + pad(Math.floor(rem / 3600)) + ':' +
           pad(Math.floor((rem % 3600) / 60)) + ':' + pad(Math.floor(rem % 60));
  }
  function pad3(n) { return n < 10 ? '00' + n : n < 100 ? '0' + n : String(n); }

  function elapsedDays(at) { return (Date.now() - at.getTime()) / 86400000; }
  function parseAt(el) { return new Date((el.dataset.at || '') + 'T00:00:00'); }

  class KahausRun extends HTMLElement {
    connectedCallback() {
      var base = parseFloat(this.dataset.total), day = parseFloat(this.dataset.day);
      var at = parseAt(this), unit = this.dataset.unit || '', sep = this.dataset.sep || ',';
      var dec = parseInt(this.dataset.dec || '0', 10), ydhms = this.dataset.fmt === 'ydhms';
      if (!isFinite(base) || !isFinite(day) || isNaN(at)) return;
      var self = this;
      function paint() {
        var v = base + elapsedDays(at) * day;
        self.textContent = ydhms ? fmtYdhms(v) : fmtNum(v, dec, sep) + (unit ? ' ' + unit : '');
      }
      paint();
      if (!REDUCE) setInterval(paint, ydhms ? 250 : 1000);
    }
  }

  class KahausSolar extends HTMLElement {
    connectedCallback() {
      var base = parseFloat(this.dataset.total), kwp = parseFloat(this.dataset.kwp);
      var at = parseAt(this), sep = this.dataset.sep || ',';
      if (!isFinite(base) || !isFinite(kwp) || isNaN(at)) return;
      var self = this;

      // Uzysk PV dla Krakowa/Niepołomic (~50°N), kWh/kWp/dobę — ŚREDNIA MIESIĘCZNA,
      // nie pogoda: w pochmurny dzień licznik zawyża, w słoneczny zaniża, w skali
      // miesiąca się zeruje. User (07-17): „weź pod uwagę nasłonecznienie średnie,
      // nie per dzień". Profil MUSI być miesięczny — wcześniej siedziała tu jedna
      // liczba (61,8 = średnia lipcowa) i licznik dopisywałby tyle samo w grudniu,
      // czyli ~5× za dużo. Błąd niewidoczny w lipcu, zabójczy w listopadzie.
      var YIELD = [1.2, 1.9, 2.9, 4.0, 4.4, 4.5, 4.4, 4.1, 3.2, 2.2, 1.2, 0.9];
      function dayKwh(d) { return YIELD[d.getMonth()] * kwp; }

      function doy(d) { return Math.floor((d - new Date(d.getFullYear(), 0, 0)) / 86400000); }
      // Wschód/zachód z deklinacji Słońca — to akurat NIE jest średnia, tylko astronomia.
      function daylight(d) {
        var dec = 23.45 * Math.PI / 180 * Math.sin(2 * Math.PI * (284 + doy(d)) / 365);
        var c = -Math.tan(LAT) * Math.tan(dec);
        if (c >= 1) return null;
        if (c <= -1) c = -1;
        var H = Math.acos(c) * 180 / Math.PI / 15;
        return { rise: 12 - H, set: 12 + H };
      }
      function frac(h, dl) {
        if (h <= dl.rise) return 0;
        if (h >= dl.set) return 1;
        var x = (h - dl.rise) / (dl.set - dl.rise);
        return x - Math.sin(2 * Math.PI * x) / (2 * Math.PI);
      }

      function paint() {
        var now = new Date();
        var v = base;
        // Doby od daty odniesienia liczone PO MIESIĄCACH — każdy dzień swoim uzyskiem.
        var cur = new Date(at.getTime());
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        while (cur < today) { v += dayKwh(cur); cur.setDate(cur.getDate() + 1); }
        var dl = daylight(now);
        if (dl) v += dayKwh(now) * frac(now.getHours() + now.getMinutes() / 60 + now.getSeconds() / 3600, dl);
        // 2 miejsca (user 07-17): przy szczycie ~62 kWh/dobę setne przeskakują co ~1,4 s,
        // więc widać, że licznik żyje — i widać też, że W NOCY STOI. To jest cecha, nie brak.
        self.textContent = fmtNum(v, 3, sep) + ' kWh';
      }
      paint();
      if (!REDUCE) setInterval(paint, 1000);   // setne ruszają się co ~1,4 s w szczycie
    }
  }

  class KahausPieces extends HTMLElement {
    connectedCallback() {
      var base = parseFloat(this.dataset.total), day = parseFloat(this.dataset.day);
      var at = parseAt(this);
      if (!isFinite(base) || !isFinite(day) || isNaN(at)) return;
      var self = this;
      var label = this.dataset.nextLabel || '';
      var unit = this.dataset.unit || '';
      // Odliczanie DOKLEJONE do liczby (inline), nie pod nią — osobna linia rozpychała
      // kafel i rząd znów się rozjeżdżał (ta sama lekcja co przy kaflu energii).
      var box = document.createElement('span');
      box.className = 'kahaus-usp__next';
      this.insertAdjacentElement('afterend', box);
      var perPieceMs = 86400000 / day;         // ~11,8 min
      function paint() {
        var exact = base + elapsedDays(at) * day;
        self.textContent = grouped(Math.floor(exact)) + (unit ? ' ' + unit : '');
        // Odliczanie do kolejnej: ile brakuje do pełnej sztuki × czas jednej
        var left = (1 - (exact - Math.floor(exact))) * perPieceMs / 1000;
        box.textContent = label + ' ' + pad(Math.floor(left / 60)) + ':' + pad(Math.floor(left % 60));
      }
      paint();
      if (!REDUCE) setInterval(paint, 1000);
    }
  }

  if (!customElements.get('kahaus-run')) customElements.define('kahaus-run', KahausRun);
  if (!customElements.get('kahaus-solar')) customElements.define('kahaus-solar', KahausSolar);
  if (!customElements.get('kahaus-pieces')) customElements.define('kahaus-pieces', KahausPieces);
})();
